import {
  ROUTE_NNC_SUMMARY_REPORT,
} from '@app/navigations/RoutePathConstant';
import {authLoader} from '@app/navigations/loader';
import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';

const NNCSummaryReport = lazy(() =>
  import('../../../screens/NNCSummaryReport')
    .then(module => ({default: module.NNCSummaryReport})));

const NNCSummaryReportNavigation = [{
  path: ROUTE_NNC_SUMMARY_REPORT,
  loader: authLoader,
  element: (
    <Suspense fallback={<Spin />}>
      <NNCSummaryReport />
    </Suspense>
  ),
},
];

export default NNCSummaryReportNavigation;
